import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  backgroundColor: (p) => p.palette.grey[50],
  borderRadius: 1,
  overflow: 'hidden',
};

export const getRootSx = (customSx?: SxStyle): SxStyle =>
  customSx ? { ...root, ...customSx } : root;

export const header: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  justifyContent: 'space-between',
  padding: (p) => p.spacing(1),
};

export const content: SxStyle = {
  padding: (p) => p.spacing(1),
};

export const wrapper: SxStyle = {
  display: 'flex',
  border: 1,
  borderColor: 'divider',
  borderRadius: 0.5,
  overflow: 'hidden',
  background: 'white',
};

export const wrapperFocused: SxStyle = {
  borderColor: 'primary.main',
};

export const getWrapperSx = (focused: boolean): SxStyle =>
  focused ? { ...wrapper, ...wrapperFocused } : wrapper;

export const contentColumn: SxStyle = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
};

export const tagsWrapper: SxStyle = {
  padding: '8px 8px 0 8px',
};

export const chevronColumn: SxStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  width: 32,
  paddingTop: 1,
  flexShrink: 0,
};

export const chevronBox: SxStyle = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: (p) => p.palette.grey[200],
  height: 'fit-content',
  borderRadius: (p) => p.spacing(0.5),
};
